/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Token and cost usage payload.
 */
export type HookUsageData = {
  /**
   * Cache read token count.
   */
  cacheReadTokens?: number | undefined;
  /**
   * Cache write token count.
   */
  cacheWriteTokens?: number | undefined;
  /**
   * Reported cost.
   */
  cost?: number | undefined;
  /**
   * Input token count.
   */
  inputTokens?: number | undefined;
  /**
   * Agent loop count, when reported.
   */
  loopCount?: number | undefined;
  /**
   * Output token count.
   */
  outputTokens?: number | undefined;
  /**
   * Provider-reported usage or session status, when available.
   */
  status?: string | undefined;
};

/** @internal */
export type HookUsageData$Outbound = {
  cache_read_tokens?: number | undefined;
  cache_write_tokens?: number | undefined;
  cost?: number | undefined;
  input_tokens?: number | undefined;
  loop_count?: number | undefined;
  output_tokens?: number | undefined;
  status?: string | undefined;
};

/** @internal */
export const HookUsageData$outboundSchema: z.ZodMiniType<
  HookUsageData$Outbound,
  HookUsageData
> = z.pipe(
  z.object({
    cacheReadTokens: z.optional(z.int()),
    cacheWriteTokens: z.optional(z.int()),
    cost: z.optional(z.number()),
    inputTokens: z.optional(z.int()),
    loopCount: z.optional(z.int()),
    outputTokens: z.optional(z.int()),
    status: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      cacheReadTokens: "cache_read_tokens",
      cacheWriteTokens: "cache_write_tokens",
      inputTokens: "input_tokens",
      loopCount: "loop_count",
      outputTokens: "output_tokens",
    });
  }),
);

export function hookUsageDataToJSON(hookUsageData: HookUsageData): string {
  return JSON.stringify(HookUsageData$outboundSchema.parse(hookUsageData));
}
